import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { scribeDocumentBase, parentContainer } from 'apps/scribe/ScribePropTypes';
import { sendAdvertAnalytics } from 'apps/analytics';
import sendPromotionClickEvent from 'apps/gtm/utils/sendPromotionClickEvent';

export default class PromoBoxContent extends PureComponent {
  static propTypes = {
    ...scribeDocumentBase,
    ...parentContainer,
    gtmPageType: PropTypes.string.isRequired,
    imageSrc: PropTypes.string.isRequired,
    imageAlt: PropTypes.string.isRequired,
    scribeDocumentType: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  };

  onClick = () => {
    const {
      docNo,
      docTitle,
      docVersionNo,
      parentContainer: {
        docTitle: parentTitle,
        docNo: parentNo,
        docVersionNo: parentVersionNo,
      },
      gtmPageType,
      scribeDocumentType,
    } = this.props;
    const id2 = `${docNo}-${docVersionNo}-${parentNo}-${parentVersionNo}`;
    sendAdvertAnalytics(this.props, this.props.parentContainer);
    sendPromotionClickEvent({
      id: docNo,
      id2,
      text: docTitle,
      creative: parentTitle,
      position: scribeDocumentType,
      gtmPageType,
    });
  };

  render() {
    const { imageSrc, imageAlt, url } = this.props;
    return (
      <Link to={url} onClick={this.onClick}>
        <img src={imageSrc} alt={imageAlt} />
      </Link>
    );
  }
}
